import { Heading, Stack, type StackProps } from '@chakra-ui/react'

import type * as url from '@/client/services/url'

import FAQHelpDeskSection from './FAQHelpDeskSection'

export default function FAQHeader({
  category,
  headerText,
  justifyHeader,
}: {
  category?: url.faq.Category
  headerText?: string
  justifyHeader?: StackProps['justifyContent']
}): JSX.Element {
  return (
    <Stack direction="column" spacing={4}>
      <Stack align="center" justify={justifyHeader} direction="row" spacing={8}>
        <Heading as="h2" size="xl">
          {headerText}
        </Heading>
      </Stack>
      <FAQHelpDeskSection category={category} />
    </Stack>
  )
}
